<!-- 解锁接口内容 -->
<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "@/components/commonStructure"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props:['commonUrls'],
    data() {
        return {
            requestBody: { cardNumber: "A12345", carNo: "粤YZZ568", unlockReason: "reason" },
            responseCode:{"data":{},"message":"未找到停车记录","resultCode":905,"status":2},
            infoData: {
                explain: "第三方接入系统请求智慧停车开放平台对指定车辆进行解锁",
                t_url: this.commonUrls.test+"unlockCar",
                p_url: this.commonUrls.prod+"unlockCar",
                precondition: "无",
                fitSystem: "VEMS传统停车场，云停车场",
                pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
                Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'carNo', info2: '否', info3: 'String', info4: '车牌号(停车记录编号、车牌号和卡牌号不能同时为空)' },
                        { info1: 'cardNumber', info2: '否', info3: 'String', info4: '卡票号(停车记录编号、车牌号和卡牌号不能同时为空)' },
                        { info1: 'unlockReason', info2: '否', info3: 'String', info4: '解锁原因' },
                        { info1: 'parkingCode', info2: '否', info3: 'String', info4: '停车记录编号(停车记录编号、车牌号和卡牌号不能同时为空)' },
                        ]
                }],
                R_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        ]
                }],
                codeStatus: [{
                    titleName: null,
                    tabledata: [{ tableHead: '状态码', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
                    td: [{ info1: '000110', info2: '失败', }, { info1: '00110000', info2: '失败', }, { info1: '110000', info2: '失败', }]
                }],
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/platform/parking/unlockCar.vue